<div id="company-view-list" class="company-view-list">
    <div class="card-view">
        <div class="company-filter">
            <div class="company-search-block">
                <input [(ngModel)]="searchString" autocomplete="off" class="" type="text">
                <button (click)="searchCompany(searchString)" mat-mini-fab color="primary"
                    aria-label="Example icon button with a menu icon">
                    <mat-icon>search</mat-icon>
                </button>
            </div>
            <div *ngIf="!isStaffImportPage" class="filter-list">
                <div class="form-wrap select-view">
                    <mat-form-field appearance="fill">
                        <mat-label>Estado de la Empresa</mat-label>
                        <mat-select [(ngModel)]="activeStatusTreeViewData" (selectionChange)="activeStatusChange(activeStatusTreeViewData)" class="pt-25">
                            <mat-option value="A">Activas</mat-option>
                            <mat-option value="I">Inactivas</mat-option>
                            <mat-option value="T">Todas</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div> 
        </div>
        <div class="company-tree-view">
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                <mat-tree-node (click)="activeNode = node" [ngClass]="{ 'mat-selectted-node ': activeNode === node,'mat-deactivate': node.status=='N','mat-strike':  node.status=='E','mat-deactivate-contacto': node.finGestion==true}" 
                    (click)="nodeOperationsLoadEmpresa(node)" *matTreeNodeDef="let node" matTreeNodeToggle
                    matTreeNodePadding matTreeNodePaddingIndent="25">
                    <p>{{node.name }}</p>
                    <button (click)="nodeOperations(node)" class="options" mat-icon-button>
                       
                    </button>
                </mat-tree-node>

                <mat-tree-node (click)="activeNode = node" [ngClass]="{ 'mat-selectted-node': activeNode === node,'mat-deactivate': node.status=='N','mat-strike':  node.status=='E','mat-deactivate-contacto': node.finGestion==true}"
                    (click)="nodeOperationsLoadEmpresa(node)" *matTreeNodeDef="let node;when: hasChild"
                    matTreeNodePadding matTreeNodePaddingIndent="15">
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name" (click)="ResetTree(node)">
                        <mat-icon class="mat-icon-rtl-mirror" >
                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                    </button>
                    <p>{{node.name}}</p>

                    <button (click)="nodeOperations(node)" class="options" mat-icon-button
                        >
                        
                    </button>
                </mat-tree-node>
            </mat-tree>


        </div>
    </div>
</div>

